import { alpha, createTheme } from "@mui/material";
const colors = {
  primary: {
    light: "#FB7500",
    dark: "#ED7B00",
  },
  secondary: {
    light: "#000000",
    dark: "#FFFFFF",
  },
};
const easyReportTheme = (colorMode) =>
  createTheme({
    palette: {
      mode: !colorMode ? "light" : "dark",
      primary: {
        main: !colorMode ? colors.primary.light : colors.primary.dark,
      },
      secondary: {
        main: !colorMode ? colors.secondary.light : colors.secondary.dark,
      },
      background: {
        default: !colorMode ? "#e9ebee" : "#141617",
        textField: !colorMode ? "#E3E3E3" : "#3a3838",
        card: !colorMode ? "#FFFFFF" : "#2e2d2d",
        cardInverted: colorMode ? "#FFFFFF" : "#2e2d2d",
        cardProfile: !colorMode ? "#E4E4E4" : "#3B3939",
        paper: !colorMode ? "#FFFFFF" : "#272727",
        switch: !colorMode ? "#E6E6E6" : "#9c9c9c",
        terminal: !colorMode ? "#ECECEC" : "#1d1c1cff",
        chipCard: !colorMode ? "#fd9a37ee" : "#fda145ee",
      },
      text: {
        primary: !colorMode ? "#212121" : "#ECECEC",
        secondary: !colorMode ? "#616161" : "#9A9A9A",
        disabled: !colorMode ? "#9E9E9E" : "#878686",
        invert: colorMode ? colors.secondary.light : colors.secondary.dark,
      },
      success: {
        main: "#04B55D",
      },
      warning: {
        main: "#FFBB00",
      },
      error: {
        main: "#FF4130",
      },
      info: {
        main: "#00B8D9",
      },
      color: {
        links: !colorMode
          ? alpha(colors.primary.light, 0.9)
          : alpha(colors.primary.dark, 0.9),
        icons: !colorMode
          ? alpha(colors.primary.light, 0.12)
          : alpha(colors.primary.dark, 0.1),
        stroke: !colorMode ? "#D8D8D8" : "#3A3A3A",
      },
      table: colorMode ? "#333333" : "#E4E4E4",
      stroke: colorMode ? "#4E4E4E" : "#E3E3E3",
      linearCarousel: {
        percent0: colorMode ? "#ffffff0a" : "#ffffffff",
        percent50: colorMode ? "#00000000" : "#ffffff85",
        percent100: colorMode ? "#ffffff02" : "#ffffff28",
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
        fh: 1920,
        qhd: 2560,
      },
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: ({ theme }) => ({
            "& .MuiInputLabel-root": {
              fontSize: "1rem", // Tamanho do texto do label
            },
            "& .MuiInputBase-input": {
              fontSize: "1rem", // Tamanho do texto do placeholder
              display: "flex",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "transparent",
              },
              boxShadow: "0px 0px 3px  #0000001a",
              backgroundColor: theme.palette.background.textField,

              /* "&.Mui-focused": {
                backgroundColor: "none",
                /*  "& fieldset": {
                  border: `1px solid  ${theme.palette.primary.main}`,
                }, 
                "&:hover": {
                  "& fieldset": {
                    border: `1px solid  ${theme.palette.primary.main}`,
                  },
                },
              }, */

              "&:hover": {
                backgroundColor: theme.palette.background.hover,
                "& fieldset": {
                  borderColor: "transparent",
                },
              },
              "&.Mui-disabled": {
                backgroundColor: alpha(theme.palette.text.disabled, 0.2),
                "& fieldset": {
                  borderColor: "transparent",
                },
                "&:hover": {
                  "& fieldset": {
                    borderColor: "none",
                  },
                },
              },
            },
          }),
        },
      },
      /*  MuiTextField: {
        styleOverrides: {
          root: ({ theme }) => ({
            "& ::placeholder": {
              color: theme.palette.text.primary,
            },
            "& .MuiInputLabel-root": {
              fontSize: "1rem",
            },
            "& .MuiInputBase-input": {
              fontSize: "1rem",
              display: "flex",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: theme.palette.divider,
                borderWidth: "1px",
              },
              boxShadow: "0px 0px 2px rgba(0,0,0,0.05)",
              backgroundColor: theme.palette.background.textField,

              "&.Mui-focused": {
                backgroundColor: "transparent",
                "& fieldset": {
                  border: `1px solid ${theme.palette.primary.main}`,
                },
                "&:hover": {
                  "& fieldset": {
                    border: `1px solid ${theme.palette.primary.main}`,
                  },
                },
              },

              "&:hover": {
                backgroundColor: theme.palette.background.textField,
                "& fieldset": {
                  borderColor: theme.palette.divider,
                },
              },
              "&.Mui-disabled": {
                backgroundColor: alpha(theme.palette.background.paper, 0.6),
                "& fieldset": {
                  borderColor: theme.palette.divider,
                },
                "&:hover": {
                  "& fieldset": {
                    borderColor: theme.palette.divider,
                  },
                },
              },
            },
          }),
        },
      }, */
      MuiButton: {
        variants: [
          {
            props: { variant: "contained" },
            style: {
              color: "#FFFFFF",
            },
          },
          {
            props: { variant: "smoth" },
            style: {
              backgroundColor: !colorMode
                ? alpha(colors.primary.light, 0.1)
                : alpha(colors.primary.dark, 0.1),
              color: !colorMode ? colors.primary.light : colors.primary.dark,
            },
          },
        ],
        styleOverrides: {
          root: {
            textTransform: "capitalize",
            boxShadow: "none",
            borderRadius: "5px",
            "&:hover": {
              boxShadow: "none",
            },
          },
        },
      },
      MuiPaper: {
        variants: [
          {
            props: { variant: "default" },
            style: {
              border: "none",
              //boxShadow: "0px 1px 2px  #0000000c",
              boxShadow: "0px 0px 4px  #0000000c",
            },
          },
          {
            props: { variant: "card" },
            style: {
              border: "none",
              boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
            },
          },
          {
            props: { variant: "brick" },
            style: {
              display: "flex",
              border: "none",
              boxShadow: "0px 0px 4px 0px  rgba(0, 0, 0, 0.25)",
              padding: "6px",
            },
          },
        ],
        defaultProps: {
          variant: "default",
        },
        styleOverrides: {
          root: {
            borderRadius: "5px",
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: ({ theme }) => ({
            "& button": {
              backgroundColor: theme.palette.background.textField,
              color: theme.palette.text.secondary,
              textTransform: "none",
              borderRadius: "4px",
            },
            "& .MuiTabs-flexContainer": {
              height: "42px",
            },
            "& button.Mui-selected": {
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
            },
            "& .MuiTabs-indicator": {
              backgroundColor: theme.palette.background.paper,
            },
          }),
        },
      },
      MuiDataGrid: {
        styleOverrides: {
          row: ({ theme }) => ({
            backgroundColor: !colorMode ? "#FBFBFC" : "#2e2e2dff",
            "&:hover": {
              backgroundColor: !colorMode ? "#F3F5F6" : "#292929ff",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: `1px solid ${theme.palette.divider}`,
            },
          }),
        },
      },
      MuiAlert: {
        styleOverrides: {
          standardWarning: ({ theme }) => ({
            ...(theme.palette.mode === "dark" && {
              backgroundColor: "#332800",
            }),
          }),
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: ({ theme }) => ({
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background.textField,
              "&:hover": {
                backgroundColor: theme.palette.background.textField,
              },
              /*   "&.Mui-focused": {
                backgroundColor: "transparent",
              }, */
            },
            "& .MuiAutocomplete-paper": {
              backgroundColor: theme.palette.background.textField,
            },
            "& .MuiAutocomplete-listbox": {
              backgroundColor: theme.palette.background.textField,
            },
            "& .MuiAutocomplete-option": {
              backgroundColor: "transparent",
            },
            "& .MuiAutocomplete-option[aria-selected='true']": {
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
            },
            "& .MuiAutocomplete-input": {
              minHeight: "unset !important",
              padding: "4px 4px !important",
            },
            "& .MuiChip-root.MuiAutocomplete-tag:not(.MuiChip-sizeMedium)": {
              maxWidth: 175,
              maxHeight: 30,
              margin: "2px",
              color: theme.palette.background.card,
              backgroundColor: alpha(
                theme.palette.background.cardInverted,
                0.6,
              ),
            },
            "& .MuiChip-deleteIcon": {
              color: theme.palette.background.default,
            },
          }),
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: ({ theme }) => ({
            "& .MuiSelect-select": {
              backgroundColor: theme.palette.background.textField,
            },
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background.textField,
              "&:hover": {
                backgroundColor: theme.palette.background.textField,
              },
              "&.Mui-focused": {
                backgroundColor: "transparent",
              },
            },
            "&.Mui-disabled .MuiSelect-select": {
              backgroundColor: alpha(theme.palette.background.paper, 0.6),
            },
          }),
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: ({ theme }) => ({
            backgroundColor: theme.palette.background.textField,
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.divider}`,
            boxShadow: "0 4px 12px rgba(16,24,40,0.06)",
          }),
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: ({ theme }) => ({
            "&:hover": {
              backgroundColor: alpha(theme.palette.primary.main, 0.04),
            },
            "&.Mui-selected": {
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
            },
          }),
        },
      },
      MuiStepIcon: {
        styleOverrides: {
          root: ({ theme }) => ({
            color: theme.palette.divider,
            "&.Mui-completed": {
              color: theme.palette.success.main, // green for completed
            },
            "&.Mui-active": {
              color: theme.palette.primary.main,
            },
          }),
          text: {
            fill: "#fff",
          },
        },
      },
    },
    mixins: {
      /*     MuiDataGrid: {
        containerBackground: !colorMode ? "#FBFBFC" : "#1E1E1E",
      }, */
    },
  });

export default easyReportTheme;
